module.exports = __webpack_public_path__ + "static/template-about-hero-background-9e32a5cecf7293a6d0324bacc324eade.jpg";